const IngredientCategories = () => import("./views/IngredientCategories.vue");
const IngredientCategoryEdit = () => import("./views/IngredientCategoryEdit.vue");

const route = "/inventory/ingredients/categories";

export default [
  {
    path: route,
    name: "inventory.ingredientCategories.list",
    component: IngredientCategories,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${route}/create`,
    name: "inventory.ingredientCategories.create",
    component: IngredientCategoryEdit,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${route}/:ingredientCategoryId/edit`,
    name: "inventory.ingredientCategories.edit",
    component: IngredientCategoryEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },
];
